import React, { useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import logo from "../assets/images/krinvy_outsourcing.gif";
import Cosection1 from "../components/Cosection1";
import Scrolltop from "../components/Scrolltop";
import WhatsAppChatButton from "../components/Whatsapp";
import "./Outsourcing.css";
import OutsourcingFaqs from '../pages/OutsourcingFaqs';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false
});

const Outsourcing = ({ showCallModal, setShowOutsourceModal }) => {
  const modalIntervalRef = useRef(null);
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    // Initialize AOS
    AOS.refresh();
    
    // Scroll to top only on initial load
    window.scrollTo(0, 0);

    // Modal handling logic
    const showModalIfNotOpen = () => {
      if (!showCallModal) {
        scrollPositionRef.current = window.pageYOffset;
        setShowOutsourceModal(true);
      }
    };

    if (!showCallModal) {
      modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000);
    }

    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
      }
    };
  }, [showCallModal, setShowOutsourceModal]);

  // Restore scroll position when modal closes
  useEffect(() => {
    if (!showCallModal && scrollPositionRef.current > 0) {
      window.scrollTo(0, scrollPositionRef.current);
      scrollPositionRef.current = 0;
    }
  }, [showCallModal]);

  // Additional effect to restart interval when modal closes
  useEffect(() => {
    if (!showCallModal && !modalIntervalRef.current) {
      modalIntervalRef.current = setInterval(() => {
        if (!showCallModal) {
          setShowOutsourceModal(true);
        }
      }, 120000);
    }
    
    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
      }
    };
  }, [showCallModal, setShowOutsourceModal]);


  const indianServices = [
    {
      title: "GST Filing",
      desc: "Timely GST return filing and reconciliation for Indian businesses."
    },
    {
      title: "Income Tax Returns (ITR)",
      desc: "Filing of individual and business ITRs as per Indian tax laws."
    },
    {
      title: "TDS Compliance",
      desc: "TDS calculation, deduction, and quarterly return filing."
    },
    {
      title: "ROC Compliance",
      desc: "Annual ROC filings, director KYC, and company maintenance."
    },
    {
      title: "Accounting & Bookkeeping (India)",
      desc: "Day-to-day accounting and maintenance of books for Indian SMEs."
    },
    {
      title: "Payroll Processing (India)",
      desc: "Payroll, PF/ESIC filings, and payslip generation for Indian employees."
    }
  ];

  const usServices = [
    {
      title: "Accounting and Bookkeeping",
      desc: "Accurate financial tracking, reconciliation, and reporting to support your business operations."
    },
    {
      title: "Digital Bookkeeping",
      desc: "Cloud-based bookkeeping solutions using tools like QuickBooks, Xero, and FreshBooks."
    },
    {
      title: "Year-End Accounts",
      desc: "Preparation of final accounts and financial statements in compliance with U.S. standards."
    },
    {
      title: "Tax Preparation",
      desc: "Federal and state tax preparation for individuals, businesses, and corporations."
    },
    {
      title: "Self-Assessment Tax Returns",
      desc: "Support for freelancers and self-employed professionals to file returns hassle-free."
    },
    {
      title: "Company Tax Returns",
      desc: "End-to-end filing of IRS-compliant corporate tax returns, including Form 1120 and 1120S."
    },
    {
      title: "Fixed Price Year-End Accounts",
      desc: "Transparent pricing for complete annual account compilation with no hidden costs."
    },
    {
      title: "Company Secretarial Services",
      desc: "Managing compliance, filings, and corporate governance documents for your U.S. business entity."
    },
    {
      title: "VAT Services",
      desc: "Assistance with U.S. Sales Tax and multi-state filings across marketplaces and platforms."
    },
    {
      title: "Audit and Assurance",
      desc: "Independent auditing and financial assurance to meet legal and investor requirements."
    },
    {
      title: "Payroll Services",
      desc: "End-to-end payroll processing including pay runs, tax withholdings, and W-2 generation."
    }
  ];

  const digitalServices = [
    {
      title: "UI/UX Designers",
      desc: "Outsource expert designers for web/mobile interfaces that boost conversions and user experience."
    },
    {
      title: "Web Developers",
      desc: "Hire frontend experts in React.js, Next.js, and more to build responsive U.S. business websites."
    },
    {
      title: "Backend Developers",
      desc: "Scale backend services with Node.js, Python, or PHP developers to power your apps and APIs."
    },
    {
      title: "Content Writers",
      desc: "Engage your audience with well-researched, SEO-optimized content and copywriting."
    }
  ];



  const renderServices = (heading, serviceList) => (
    <section className="outsourcing-section" data-aos="fade-up">
      <h2 className="outsourcing-section-title" data-aos="fade-up" data-aos-delay="100">
        {heading}
      </h2>
      <div className="outsourcing-grid">
        {serviceList.map((service, index) => (
          <div 
            key={index} 
            className="outsourcing-card"
            data-aos="fade-up"
            data-aos-delay={150 + (index * 50)}
          >
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <>
      <Navbar />
      <div className="outsourcing-wrapper">
        {/* Hero Section with Animations */}
        <section className="outsourcing-hero" data-aos="fade-up">
          <img
            src={logo}
            alt="Krinvy Logo"
            className="outsourcing-logo"
            data-aos="zoom-in"
            data-aos-delay="100"
          />
          <h1 className="outsourcing-title" data-aos="fade-up" data-aos-delay="200">
            Outstanding Outsourcing Services
          </h1>
          <p className="outsourcing-subtitle" data-aos="fade-up" data-aos-delay="300">
            Streamline your operations with skilled outsourcing in Indian taxation, U.S. compliance, and digital tech.
          </p>
        </section>

        {/* Animated Service Sections */}
        {renderServices("U.S. Accounting & Taxation Services", usServices)}
        {renderServices("Indian Accounting & Taxation Services", indianServices)}
        {renderServices("Digital Services", digitalServices)}
        
        {/* FAQ Section */}
        <div data-aos="fade-up">
          <OutsourcingFaqs />
        </div>
      </div>
      <Scrolltop />
      <WhatsAppChatButton />
      <Cosection1 setShowOutsourceModal={setShowOutsourceModal} />
      <Footer />
    </>
  );
};

export default Outsourcing;